module.exports = __webpack_public_path__ + "media/sapa_archive/SAPAbg620x50-5bd838dd.gif";